export default "Calculer mes aides 2026 — CEE & MaPrimeRénov’ | Solution Éco France";
